import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "routes/dashboard/dialogues/dialogue-styles";
import { TextField, FormControl } from "@material-ui/core";
import { withSnackbar } from "notistack";
import { toast } from "react-toastify";
import Popup from "components/popup";
import { withRouter } from "react-router-dom";

// Actions
// import { AllCoursesContext } from "repository/stores/dashboard/courses/courses-all-provider";
// import { editCourse } from "repository/actions/data/dashboard/courses";

const useStyles = makeStyles(styles);

function AddMenuDialogue(props) {
  const classes = useStyles();

  const { setClose, isOpen, data, itemId, user, editCourse } = props;

  // const {courses, setCourses, editCourse} = React.useContext(AllCoursesContext);

  const [title, setTitle] = React.useState(null);
  const [description, setDescription] = React.useState(null);
  const [mqfLevel, setMqfLevel] = React.useState(null);
  const [referenceNumber, setReferenceNumber] = React.useState(null);

  const [saveLoading, setSaveLoading] = React.useState(false);

  const [titleError, setTitleError] = React.useState(null);
  const [descriptionError, setDescriptionError] = React.useState(null);
  const [mqfError, setMqfError] = React.useState(null);
  const [referenceError, setReferenceError] = React.useState(null);

  useEffect(() => {
    if (data) {
      setTitle(data.title);
      setDescription(data.description);
      setMqfLevel(data.mqfLevel);
      setReferenceNumber(data.referenceNumber);
    }
  }, [data]);

  const handleSaveOwnerDetails = () => {
    if (user && user != null) {
      if (
        title == null ||
        description == null ||
        mqfLevel == null ||
        referenceNumber == null
      ) {
        toast.error("You have missing information for editing this course");
        if (title === null) {
          setTitleError("Title is required.");
        }

        if (description == null) {
          setDescriptionError("Description is required.");
        }

        if (mqfLevel == null) {
          setMqfError("MQF Level is required.");
        }

        if (referenceNumber == null) {
          setReferenceError("Reference Number is required.");
        }
      } else {
        let saveData = {
          title: title,
          description: description,
          mqfLevel: mqfLevel,
          referenceNumber: referenceNumber,
        };

        setSaveLoading(true);

        editCourse(saveData, itemId, user.idToken)
          .then((result) => {
            toast.success(`Successfully edited ${title}`);
            setClose();
            setSaveLoading(false);
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    }
  };

 

  return (
    <Popup
      title="Edit existing course"
      subtitle="You can modify the following course details."
      isOpen={isOpen}
      fullWidth={true}
      maxWidth={"sm"}
      handleCancel={() => setClose()}
      handleAction={() => handleSaveOwnerDetails()}
      actionButtonTitle="Submit"
      disabled={saveLoading}
      content={
        <div className={classes.root}>
          <FormControl className={classes.formControl}>
            <TextField
              placeholder={"Ex: Module Title"}
              disabled={saveLoading}
              required
              helperText={titleError}
              error={titleError != null}
              label="Title"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              margin="normal"
            ></TextField>
          </FormControl>
          <div></div>
          <FormControl className={classes.formControl}>
            <TextField
              placeholder={"Ex: Module Description"}
              disabled={saveLoading}
              required
              helperText={descriptionError}
              error={descriptionError != null}
              label="Description"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
              margin="normal"
            ></TextField>
          </FormControl>
          <div></div>
          <FormControl className={classes.formControl}>
            <TextField
              placeholder={"Ex: MQF Level"}
              disabled={saveLoading}
              required
              helperText={mqfError}
              error={mqfError != null}
              label="MQF Level"
              value={mqfLevel}
              onChange={(event) => setMqfLevel(event.target.value)}
              margin="normal"
            ></TextField>
          </FormControl>
          <div></div>
          <FormControl className={classes.formControl}>
            <TextField
              placeholder={"Ex: M1263"}
              disabled={saveLoading}
              required
              helperText={referenceError}
              error={referenceError != null}
              label="Reference Number"
              value={referenceNumber}
              onChange={(event) => setReferenceNumber(event.target.value)}
              margin="normal"
            ></TextField>
          </FormControl>
          <div></div>
        </div>
      }
    />
  );
}

export default withSnackbar(withRouter(AddMenuDialogue));
